<template>
    <select :value="value" @input="$emit('input', $event.target.value)" :disabled="!editable" class="form-select">
        <option :value="emptyValue" :disabled="!emptiable">{{ empty_label }}</option>
        <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
    </select>
</template>

<script type="text/javascript">
import { forOwn, orderBy } from "lodash"

import misc_utilities from "../mixins/MiscUtilities"

export default {
    mixins: [misc_utilities],
    computed: {
        empty_label () {
            if((this.emptyLabel === null) || (this.emptyLabel === undefined)) return this.$root.translate("(Pick a country)")
            return this.emptyLabel
        },
        options () {
            const countries = []

            forOwn(this.constants("countries"), (name, id) => countries.push({ id, name }))

            return orderBy(countries, ["name"], ["asc"])
        }
    },
    props: {
        value: {
            validator: prop => {
                return (typeof prop === "string") || (prop === null)
            }
        },
        editable: {
            type: Boolean,
            default: true
        },
        emptiable: {
            type: Boolean,
            default: false
        },
        emptyValue: {
            default: ""
        },
        emtpyLabel: {
            validator: prop => {
                return (typeof prop === "string") || (prop === null)
            }
        }
    }
}
</script>
